const toUpper = require('mn-utils/toUpper');

const DEV = process.env.MOCK
  || process.env.DEV;

const TESTING = process.env.TESTING
  || process.env.SANDBOX;

const SOL_URL_POSTFIX = DEV
  ? '?cluster=devnet'
  : TESTING
    ? '?cluster=testnet'
    : '';

const KLUB_URL_POSTFIX = '/token-transfers';

const EXPLORER_MAP = {
  SOL: SOL_URL_POSTFIX,
  KLUB: KLUB_URL_POSTFIX
};


module.exports = (coinCode) => {
  return EXPLORER_MAP[toUpper(coinCode || '').split('_')[0]];
};
